module.exports = __webpack_public_path__ + "static/media/stat03.14038af1.png";